/**
 * @description 告警管理 alarmManage
 * @author 系统生成
 * @date 2021/08/07
 */

import Logic from '../logic-base'

const alarmManageBiz = new Logic()

alarmManageBiz.getAlarmList = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.alarmManage.getAlarmList,
    data: data
  })
};

alarmManageBiz.updateAlarm = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.alarmManage.updateAlarm,
    data: data
  })
};

alarmManageBiz.batchUpdateAlarm = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.alarmManage.batchUpdateAlarm,
    data: data
  })
};

alarmManageBiz.getUsers = function (data = {}) {
  return this.ajax({
    ...this.REQUEST_OPT.alarmManage.getUsers,
    data: Object.assign({ group: '006' }, data)
  })
};

export default alarmManageBiz
